module.exports = __webpack_public_path__ + "static/fonts/Montserrat-ExtraLight.570a244.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-ExtraLight.ttf
// module id = jzbh
// module chunks = 1